import { render, staticRenderFns } from "./DedicationItemView.vue?vue&type=template&id=f93cc0a4&scoped=true&"
import script from "./DedicationItemView.vue?vue&type=script&lang=js&"
export * from "./DedicationItemView.vue?vue&type=script&lang=js&"
import style0 from "./DedicationItemView.vue?vue&type=style&index=0&id=f93cc0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93cc0a4",
  null
  
)

export default component.exports